import React,{useState} from "react";
import SearchBar from "../../components/universal/SearchBar";
import { allCurriculumData, allCurriculumHeaders } from "./Constants";
import CustomTable from "../../components/universal/CustomTable";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useNavigate,useLocation } from "react-router-dom";
import { HiOutlineFilter } from "react-icons/hi";
import { AllCurriculumHooks } from "./hooks/CurriculumHooks";
import Navbar from "../../components/universal/Navbar";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "../../components/universal/ConfirmToast";
import CurriculumModal from "./CurriculumModal"
import { useSelector } from "react-redux";
function AllCurriculum({church,selectedCurriculums}) {
  const {
    value,
    onChangeSearchBar,
    handleDeleteItem,
    reloadData,
    setReloadData,
    fetchAllCurriculums,
  } = AllCurriculumHooks();

  const navigate = useNavigate();
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
       const { userInfo } = useSelector((state) => state.user);

  const hideUI = location.pathname.includes("addfield")|| userInfo?.roleCode==='17dwer8'||location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");

  return (
    <>

    <div className={`App  ${!hideUI?'min-h-screen bg-[#191919] flex p-4 h-fit':'px-4'} `}>
     {!hideUI&&<Navbar />}
      <div className={`flex-1 ${!hideUI && 'md:pl-32'} md:pt-0 pt-20`}>
        <div className="flex flex-col gap-4 h-full">
          {!hideUI&&<SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />}
          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className={`flex w-full ${!hideUI ?'justify-between':'justify-end'} md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2`}>
            { !hideUI && <p className=" text-white text-3xl font-medium">Curriculum</p>}
              <div className="flex gap-4">
                {/* <Link to={"/allLanguages"}>
                  <button className="flex items-center gap-16 text-[13px] text-greyish border px-4 py-2 border-greyish bg-blackish rounded-xl">
                    All
                    <HiOutlineFilter />
                  </button>
                </Link> */}
{!hideUI &&
  <button
    onClick={() => navigate("/curriculum/add")}
    className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
  >
    <AiOutlinePlus /> Create Curriculum
  </button>
}


        {/* <button onClick={()=>setIsModalOpen(true)}>
        Create Curriculum
                </button> */}
              </div>
            </div>
            <div className={`${hideUI && 'relative'}`}>
                        { hideUI &&
                          <div className={`flex gap-4 absolute ${!hideUI ? 'right-0' : 'right-0 top-[-1.5rem]'} mt-2`}>
                         <button
    onClick={() => {
      setSelectedRow(null); // empty row for "new"
      setIsModalOpen(true);
    }}
    className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
  >
    <AiOutlinePlus /> Create Curriculum
  </button>
              </div>
              }
              <CustomTable
                searchFor={"Curriculums"}
                heightDesktop={"h-[72vh]"}
                width={"w-16"}
                // giving extra width to 2nd column
                nthChildWidth={
                  "[&>*:nth-child(2)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-32 [&>*:nth-child(3)]:w-32"
                }
                data={[]}
                headers={allCurriculumHeaders}
                customDataFetch={true}
                customDataFetchFunction={fetchAllCurriculums}
                reloadData={reloadData}
                setReloadData={setReloadData}
                reverseTable={true}
                notificationTable={true}
                nthChildStyle={"[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"}
                handleToggleClick={(row, isActive) => {
                                  }}
                handleEyeClick={(row) => {
                  if (hideUI) {
                    setSelectedRow(row);
                    setIsModalOpen(true);
                  } else {
                    navigate("/curriculum/add", { state: { _id: row?._id } });
                  }
                }}
                handleEditClick={(row) => {
                  if (hideUI) {
                    setSelectedRow(row); // pass row into modal
                    setIsModalOpen(true);

                  } else {
                    navigate("/curriculum/add", { state: { _id: row?._id } })
                  }
                  // navigate("/curriculum/add", { state: { _id: row?._id } });
                }}
                handleDeleteClick={(row) => {
                  const options = {
                    customUI: ({ onClose }) => {
                      return (
                        <ConfirmToast
                          title="Are you sure?"
                          message="You want to delete this curriculum?"
                          onClose={() => onClose()}
                          onSuccess={() => {
                            handleDeleteItem(row?._id);
                            onClose();
                          }}
                        />
                      );
                    },
                    closeOnEscape: true,
                    closeOnClickOutside: true,
                    keyCodeForClose: [8, 32],
                    overlayClassName: "!bg-gray-500 !bg-opacity-75",
                  };

                  confirmAlert(options);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <CurriculumModal
  isOpen={isModalOpen}
  onClose={() => setIsModalOpen(false)}
  rowData={selectedRow}
  hideUI={hideUI}
  church={church}
  selectedCurriculums={selectedCurriculums}
/>

</>
  );
}

export default AllCurriculum;
